module.exports = __webpack_public_path__ + "static/media/b0_p8_clickable_b.16b937fd.png";